"use client";

import { Subsidiary } from "../types";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@/components/ui/table";
import { Pencil, Trash2 } from "lucide-react";

interface SubsidiaryTableProps {
  subsidiaries: Subsidiary[];
  onEdit: (subsidiary: Subsidiary) => void;
  onDelete: (subsidiary: Subsidiary) => void;
  onAdd: () => void;
}

export function SubsidiaryTable({
  subsidiaries,
  onEdit,
  onDelete,
  onAdd
}: SubsidiaryTableProps) {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button onClick={onAdd}>Neue Gesellschaft</Button>
      </div>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Standort</TableHead>
              <TableHead className="w-[100px]">Aktionen</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {subsidiaries.map((subsidiary) => (
              <TableRow key={subsidiary.id}>
                <TableCell>{subsidiary.name}</TableCell>
                <TableCell>{subsidiary.location}</TableCell>
                <TableCell>
                  <div className="flex space-x-2">
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEdit(subsidiary)}
                    >
                      <Pencil className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onDelete(subsidiary)}
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
